import { render, staticRenderFns } from "./BedChangeReport.vue?vue&type=template&id=7d582b66&scoped=true&"
import script from "./BedChangeReport.vue?vue&type=script&lang=js&"
export * from "./BedChangeReport.vue?vue&type=script&lang=js&"
import style0 from "./BedChangeReport.vue?vue&type=style&index=0&id=7d582b66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d582b66",
  null
  
)

export default component.exports